import { render, staticRenderFns } from "./onebox-report.vue?vue&type=template&id=4000892d&scoped=true&"
import script from "./onebox-report.vue?vue&type=script&lang=js&"
export * from "./onebox-report.vue?vue&type=script&lang=js&"
import style0 from "./onebox-report.vue?vue&type=style&index=0&id=4000892d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000892d",
  null
  
)

export default component.exports